import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import * as actions from "../../stores/actionsList"


class MyHubs extends Component {
    state = {
        connections: {}
    }
    componentDidMount() {
        let updates = this.props.connection.connections
        let connections = {}
        for (let i = 0; i < updates.length; i++) {
            if (!connections[updates[i]?.appletHub?.name]) {
                connections[updates[i]?.appletHub?.name] = []
            }
            connections[updates[i]?.appletHub?.name].push(updates[i])
        }
        console.log('connections', connections)
        this.setState({ connections: connections })
    }
    render() {

        return (
            <div className="w-100 scroll-no-scrollbar tower-body h-100 px-2" style={{ overflowX: 'hidden', left: 0, width: '100%', borderRadius: '0px' }}>
                <button className='px-1 flexc pt-3 pb-3' onClick={() => this.props.changeStage('Home')} >
                    <div className="flexcc mrd-1" style={{}}>
                        <img src='/assets/icons/tower/arrow-left-gray.svg' width={'22px'} className='rtl-button' style={{ cursor: 'pointer' }} />
                    </div>
                    <p className="font-size-13 main-c6" style={{}}>{translate('Updates')}</p>
                </button>
                <div className="px-3">
                    {Object.keys(this.state.connections).map((key, index) => {
                        return (
                            <div>
                                <p className="font-size-14 weight-600 pt-3 pb-1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{key}</p>
                                {this.state.connections[key].map((item, index) => {
                                    return (
                                        <div className=" py-2 flexc w-100" style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid rgb(246, 246, 246)' }}
                                        // onClick={() => this.goToApplet(prop.applet)}
                                        >
                                            <div>
                                                <div className=" flexcc" style={{}}>
                                                    <img src={item.applet?.image ? imageAddress(item.applet?.image) : ('/assets/icons/applets/' + ((item.applet?.features && item.applet?.features[0]) ? String(item.applet?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} />
                                                </div>
                                            </div>
                                            <div className="px-2 w-90" >
                                                <div className=" w-100">
                                                    <p className="mb-0 text-bold" style={{ fontSize: 14, fontWeight: 500, color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.applet?.name)}</p>
                                                    <p className="mb-0 text-bold" style={{ fontSize: 10, fontWeight: 500, color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.appletHub?.name)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )

                    })}
                </div>
            </div>

        )
    }
}
const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif, connection: state.connection });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(MyHubs);